'use strict';

var core = require('core/wishlist/components/toggleProduct');

core.methods.hijackSwatchClick = function() {
    $('body').on('click.swatch-link', '.product-tile .swatch-link', module.exports.methods.eventHijackSwatchClick);
};

module.exports = core;
